
import { GameList } from "../../src/list/GameList";
import Script from "next/script";
import { Assets } from "../../src/list/Assets";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import dynamic from 'next/dynamic';
// import HorizontalScroll  from '/src/components/HorizontalScroll.js'
import { Suspense } from 'react'
import SkeletonLoader from '../../src/components/SkeletonLoader';
import Ad_728x90_Bot from '../../src/ads/Ad_728x90_Bot';
import GameCommonDis from "../../src/Description/GameCommonDis";
import { Tags } from "../../src/list/Tags";
import { viewMoreUrls } from "../../src/list/viewMoreUrls";
import styles from '../../styles/tags.module.css';
import CatDis from "../../src/Description/CatDis";
import CategoryGames  from '../../src/components/CategoryGames.js';
// Schema
import Breadcrumb from "../../src/schema/Breadcrumb";

const Game_Components = dynamic(() => import('../../src/components/Game_Components'), {  });
const Headcom = dynamic(() => import('../../src/components/Headcom'), {  });
const CatBtn = dynamic(() => import('../../src/components/CatBtn'), {  });
const HomeDis = dynamic(() => import('../../src/Description/HomeDis'), {  });
const FooterDis = dynamic(() => import('../../src/Description/FooterDis'), {  });
const Pagination = dynamic(() => import('../../src/components/Pagination'), {  });
const CookieCom = dynamic(() => import('../../src/components/CookieCom'), {  });
const Searchcom = dynamic(() => import('../../src/components/Searchcom'), {  });
const BannerCom = dynamic(() => import('../../src/components/BannerCom'), {  });
const FooterCom = dynamic(() => import('../../src/components/FooterCom'), {  });
const Ad_320x50 = dynamic(() => import('../../src/ads/Ad_320x50'), {  });
const BlackScreen = dynamic(() => import('../../src/components/BlackScreen'), {  });
const Snow_fx = dynamic(() => import('../../src/fx/Snow_fx'), {  });
const HorizontalScroll = dynamic(() => import('../../src/components/HorizontalScroll'), {
  loading: () => <SkeletonLoader/>,
});


export async function getStaticPaths() {
  return {
    paths: Tags.map((page) => ({
      params: { id: page.name },
    })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  return {
    props: {
      Tags,
    },
  };
}

export default function HomePage() {

  const path = useRouter();
  const [mobile, setMobile] = useState(false);

  
  useEffect(() => {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    setMobile(isMobile);
  }, []);
  

// *************************************************************


function bottomDis(value) {
  var myCom;
  if (value.dis != null) {
    myCom = <CatDis name={value.h2} dis={value.dis} />;
  }

  return myCom;
}


function pageName(name) {
  var myArray;
  var i;
  for (i = 0; i < Tags.length; i++) {
    if (name == Tags[i].name) {
      myArray = Tags[i];
      keyWord = Tags[i];
      break;
    }
  }
  return myArray;
}


const first50Games = GameList.slice(0, 50);
const pathName = path.query.id;
var keyWord;


const getGamesByTag = (tag) => {
  try {
    if (!GameList || !Array.isArray(GameList)) {
      console.error('GameList is undefined or not an array');
      return [];
    }

    const filteredGames = GameList.filter(game => game.tag.includes(tag));

    // while (filteredGames.length < 10) {
    //   filteredGames.push(...filteredGames.slice(0, 10 - filteredGames.length));
    // }

    return filteredGames.slice(0, 30);
    // return filteredGames;
  } catch (error) {
    console.error('Error filtering games:', error);
    return [];
  }
};


  const router = useRouter();
  const { page = 1 } = router.query; // Get the current page from the URL query
  const [currentPage, setCurrentPage] = useState(1);
  const gamesPerPage = 70;
  
  useEffect(() => {
    setCurrentPage(parseInt(page, 10)); // Update current page when URL query changes
  }, [page]);
  

  const getPaginatedGames = (page) => {
    const startIndex = (page - 1) * gamesPerPage;
    const endIndex = startIndex + gamesPerPage;
    return getGamesByTag(pageName(pathName).key).slice(startIndex, endIndex);
  };
  const paginatedGames = getPaginatedGames(currentPage);
  
  const handlePageChange = (newPage) => {
    router.push({
      pathname: router.pathname,
      query: { ...router.query, page: newPage }, // Maintain existing query parameters
    });
  };

  return (
    <>
      <div className="app_cont_game">
        <Headcom
          title={pageName(pathName).title}
          s_dis={pageName(pathName).s_dis}
          path={pageName(pathName).path[1] + pageName(pathName).path[0]}
          thumb={pageName(pathName).thumb}
          logo_16={Assets[0].logo_16}
          // logo_32={Assets[0].logo_32}
          logo_192={Assets[0].logo_192}
          logo_270={Assets[0].logo_270}
          logo_512={Assets[0].logo_512}
        />
        <Breadcrumb 
      name1={"Games"}
      link1={pageName(pathName).path[1]}
      name2={pageName(pathName).h1}
      link2={pageName(pathName).path[1]+pageName(pathName).path[0]}
      />
        <div>
        
          <BlackScreen />
          <div className="game-root">
            <div className="container">
           
                { pageName(pathName).key =="Homepage"&&<>
                  <div className={styles.header}>
              <h1>{pageName(pathName).h1} </h1> 
            </div>
            <div className={styles.page_dis}>
      {pageName(pathName).page_dis !=undefined && <p>{pageName(pathName).page_dis}</p>} 
      </div>
            <Game_Components/>
                </>}

                { pageName(pathName).key !="Homepage"&&<>

                  
                  <CategoryGames games={getPaginatedGames(currentPage)} category={pageName(pathName).h1} dis={pageName(pathName).page_dis}  />
                  {!mobile && <Ad_728x90_Bot />} 
                </>}
          <CatBtn />
          {bottomDis(pageName(pathName))}
          <GameCommonDis />
          <FooterDis />
          <CookieCom />
            </div>
          </div>
          
        </div>
      </div>
      <FooterCom />
      <Snow_fx />
    </>
  );
}